const ordersStyles = (theme) => ({
  container: {
    padding: 3,
    display: "flex",
    justifyContent: "center",
    backgroundColor: theme.palette.mode === "light" ? "#f4f6f9" : "#121212",
    minHeight: "100vh",
    fontFamily: "'Space Grotesk', serif",
  },
  card: {
    width: "100%",
    maxWidth: 650,
    boxShadow: 5,
    borderRadius: 2,
    padding: 3,
    backgroundColor: theme.palette.mode === "light" ? "rgba(255, 255, 255, 0.7)" : "rgba(44, 44, 44, 0.7)",
    backdropFilter: "blur(10px)",  
  },
  cardContent: {
    color: theme.palette.mode === "light" ? "text.primary" : "white",
    fontFamily: "'Space Grotesk', serif",
  },
  heading: {
    marginBottom: 3,
    textAlign: "center",
    color: theme.palette.mode === "light" ? "text.primary" : "white",
    fontFamily: "'Space Grotesk', serif",
  },
  subheading: {
    fontFamily: "'Space Grotesk', serif",
    color: theme.palette.mode === "light" ? "text.secondary" : "#aaa",
  },
  button: {
    flex: 1,
    fontWeight: 600,
    padding: "10px 15px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
      boxShadow: 3,
    },
  },
  buttonCancel: {
    flex: 1,
    fontWeight: 600,
    padding: "10px 15px",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.error.dark,
      boxShadow: 3,
    },
  },
  countdown: {
    fontFamily: "'Space Grotesk', serif",
    fontWeight: 600,
    fontSize: "1.8rem",
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: 1.2,
    color: theme.palette.mode === "light" ? "green" : "#00e676",
  },
  timeExpired: {
    fontFamily: "'Space Grotesk', serif",
    fontWeight: 600,
    color: theme.palette.mode === "light" ? "red" : "#ff4d4d",
    fontSize: "1.5rem",
    textAlign: "center",
    textTransform: "uppercase",
    letterSpacing: 1.5,
    animation: "pulse 1s infinite",
  },
  noOrderContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "100px",
    width: "100%",
  },
  noOrderText: {
    fontFamily: "'Space Grotesk', serif",
    fontSize: "18px",
    fontWeight: "bold",
    color: theme.palette.text.secondary,
  },
});

export default ordersStyles;
